/* Presentation only. Shopify owns visibility, preferences and consent storage. */
(() => {
  if (window.dhCookiePresentation) return;
  window.dhCookiePresentation = true;

  const copy = {
    cs: {
      title: 'Cookies po vašem.',
      body: 'Nezbytné cookies drží web v chodu. Ostatní cookies a podobné technologie používáme my i partneři včetně Shopify jen se souhlasem pro měření, přizpůsobení webu a reklamu.',
      privacy: 'Více o soukromí', manage: 'Nastavit jednotlivě',
      accept: 'Přijmout všechny', decline: 'Odmítnout volitelné',
      acceptNote: 'Odkud přicházíte + reklamy na míru.',
      declineNote: 'I tak můžete v klidu nakoupit.'
    },
    sk: {
      title: 'Cookies po vašom.',
      body: 'Nevyhnutné cookies držia web v chode. Ostatné cookies a podobné technológie používame my aj partneri vrátane Shopify len so súhlasom na meranie, prispôsobenie webu a reklamu.',
      privacy: 'Viac o súkromí', manage: 'Nastaviť jednotlivo',
      accept: 'Prijať všetky', decline: 'Odmietnuť voliteľné',
      acceptNote: 'Odkiaľ prichádzate + reklamy na mieru.',
      declineNote: 'Aj tak môžete v pokoji nakúpiť.'
    }
  };

  function note(kind, text) {
    const p = document.createElement('p');
    p.id = `dh-cookie-note-${kind}`;
    p.className = `dh-cookie-note dh-cookie-note--${kind}`;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 28 28');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', 'M24 24C9 25 8 12 13 4M6 8L13 3L17 11');
    svg.append(path);
    p.append(svg, document.createTextNode(text));
    return p;
  }

  function enhance() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.dhCookies === 'ready') return;
    const lang = document.documentElement.lang.toLowerCase().split('-')[0];
    const text = copy[lang];
    // Unknown locales and changed Shopify markup keep the complete native UI.
    if (!text) return;
    const body = banner.querySelector('.shopify-pc__banner__body');
    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const paragraph = body?.querySelector('p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const buttons = banner.querySelector('.shopify-pc__banner__btns');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (![body, title, paragraph, policy, buttons, accept, decline, manage].every(Boolean)) return;

    const links = document.createElement('div');
    links.className = 'dh-cookie-links';
    policy.textContent = text.privacy;
    manage.textContent = text.manage;
    links.append(manage, policy);
    title.textContent = text.title;
    paragraph.textContent = text.body;
    body.append(links);
    accept.textContent = text.accept;
    decline.textContent = text.decline;
    for (const [kind, button] of [['accept', accept], ['decline', decline]]) {
      const annotation = note(kind, text[`${kind}Note`]);
      buttons.append(annotation);
      const descriptions = new Set((button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      descriptions.add(annotation.id);
      button.setAttribute('aria-describedby', [...descriptions].join(' '));
    }
    banner.dataset.dhCookies = 'ready';
  }

  function start() {
    enhance();
    // Shopify inserts/remounts the banner asynchronously, including in Theme Editor.
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.querySelector?.('#shopify-pc__banner'))))) enhance();
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
